// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Bj-z","breadcrumbItem":"Cj-z","hideOnMobile":"Dj-z"};